import FollowupRepository from '@/shared/http/repositories/associate/followup'
import moment from 'moment'
import { advancedOnException } from '@/components/tools/Utils'

const createNewFollowupWithCard = (document, followupEvent, detailsMessage, userIp, latitude, longitude, cardId, despesas = null) => {
  const FollowupData = {
    id: null,
    document: document,
    despesas: despesas,
    mnemonic: followupEvent,
    data: moment().format('YYYY-MM-DD') + 'T' + moment().format('HH:mm:ss'),
    detalhes: detailsMessage,
    autor: null,
    ip: userIp,
    latitude: latitude,
    longitude: longitude,
    kmInicial: 0,
    kmFinal: 0,
    cardId: cardId
  }
  let formData = new FormData()
  let json = new Blob([JSON.stringify(FollowupData)], { type: 'application/json' })
  formData.append('data', json)
  formData.append('file', [])
  FollowupRepository.CreateWithMnemonic(formData)
    .then((response) => {
      return response
    })
    .catch(e => advancedOnException(e, this.$lang))
}

export { createNewFollowupWithCard }



// WEBPACK FOOTER //
// ./src/components/tools/FollowupTools.js